import { Component, OnInit , AfterViewInit, ViewEncapsulation } from '@angular/core';
import {MatTab} from '@angular/material';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { SouscripteurServiceClient } from '../services/souscripteur.service';
import { ContratService } from '../services/contrat.service';
import { Souscripteur } from '../models/souscripteur.model';
import { Paiement } from '../models/paiement.model';
import { Contrat } from '../models/contrat.model';
import { Beneficiaire } from '../models/beneficiaire.model';
import { ActivatedRoute } from '@angular/router';
import 'rxjs/add/operator/filter';
import { CheckTokenService } from '../../common/services/check-token.service';
import { AuthorizationService } from '../../common/services/authorization.service';


@Component({
  selector: 'tab-component',
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.css'],

  encapsulation: ViewEncapsulation.None

})
export class TabComponent implements OnInit {

  police: string;
  souscripteurId: any;
  souscripteur: any;
  //public souscripteur: Souscripteur;
  public paiements: Paiement[];
  beneficiaires: Beneficiaire[];
  contrat: Contrat;

  constructor(private authorizationService: AuthorizationService, private checkTokenService: CheckTokenService, private souscripteurServiceClient: SouscripteurServiceClient,  private route: ActivatedRoute, private contratService: ContratService) {
              this.authorizationService.isAdmin();

  }

 
ngOnInit(){
  this.checkTokenService.verifyToken();
  this.route.queryParams
      .filter(params => params.id)
      .subscribe(params => {
        ///console.log(params); // {order: "popular"}

        this.police = params.id;
        this.souscripteurId = params.souscripteur;
        ///console.log(this.police); // popular
        ///console.log(this.souscripteurId); // popular
      });

    this.contratService.getContrat(this.police).subscribe(
        data => {
          //console.log("Data: " + data.id + "Nom: " + data.firstName + "Prenom: " + data.lastName);
            this.contrat = data;
            this.beneficiaires = this.contrat.beneficiaire;
            this.paiements = this.contrat.paiement
            
            ///console.log( this.contrat);
            
        }); 

        // Souscripteur.
        this.souscripteurServiceClient.getSouscripteur(this.souscripteurId).subscribe(
          data => {
            ///console.log("Data: " + data.id + "Nom: " + data.firstName + "Prenom: " + data.lastName);
              this.souscripteur = data;
              
          }); 

          


}

toNumber(value: string) {

  let val =  value.replace(/\s/g, "");

  return +val;

}

// Calcul age de l'assure

calculerAge(dateNaiss) {

  let oldDate = new Date(dateNaiss);

  let newDate = new Date();

  return Math.floor(((newDate.getTime()-oldDate.getTime())/(1000 * 3600 * 24))/365.25);

 }


   
}



// WEBPACK FOOTER //
// ./src/app/client-app/tab/tab.component.ts